var map = {
	"./Logout.png": 4377,
	"./address.png": 4378,
	"./assignLogo.svg": 4379,
	"./bath.png": 4380,
	"./bed.png": 4381,
	"./calender.png": 4382,
	"./cardIcons.jpg": 4383,
	"./cards.png": 4384,
	"./company.png": 4385,
	"./customer.svg": 4386,
	"./default.png": 4387,
	"./dennisRitchie.jpg": 4388,
	"./downIcon.png": 4389,
	"./downIconHolder.png": 4390,
	"./dropdown.png": 4391,
	"./error.png": 563,
	"./header.png": 564,
	"./home.png": 4392,
	"./info.png": 4393,
	"./logo-final.jpg": 4394,
	"./logo-final.png": 299,
	"./logo-full.png": 4395,
	"./logo.jpg": 300,
	"./logo.png": 4396,
	"./logout copy.png": 4397,
	"./message.png": 4398,
	"./notify.png": 4399,
	"./office.png": 4400,
	"./offline.png": 4401,
	"./online.png": 4402,
	"./phone.png": 4403,
	"./recty.png": 4404,
	"./reject.png": 4405,
	"./search.png": 555,
	"./tick.png": 296
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4376;